import React from 'react';
import { LanguageProvider } from '../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEOHelmet from '../components/SEOHelmet';
import { getOrganizationSchema, getRealEstateAgentSchema, getFAQSchema } from '../utils/schemas';
import HeroSection from '../components/sections/HeroSection';
import MarketStatsSection from '../components/sections/MarketStatsSection';
import ServicesSection from '../components/sections/ServicesSection';
import PropertiesSection from '../components/sections/PropertiesSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import BlogSection from '../components/sections/BlogSection';
import ClientsSection from '../components/sections/ClientsSection';
import CTASection from '../components/sections/CTASection';

const HomePage = () => {
  // Combine all schemas for homepage
  const homeSchemas = [
    getOrganizationSchema(),
    getRealEstateAgentSchema(),
    getFAQSchema()
  ];

  return (
    <div className="min-h-screen">
      <SEOHelmet
        title="Net Gains Real Estate - Premier Commercial Real Estate in Dubai | 6-12% ROI"
        description="Dubai's leading commercial real estate investment firm. Specializing in high-ROI properties (6-12% annually) across Dubai Marina, Downtown Dubai, Business Bay & Palm Jumeirah. Expert market analysis, property management, and acquisition services for international investors seeking premium Dubai real estate opportunities."
        url="https://netgainsrealestate.ae"
        image="https://netgainsrealestate.ae/hero-image.jpg"
        type="website"
        schema={homeSchemas}
      />
      <Navbar />
      <HeroSection />
      <MarketStatsSection />
      <ServicesSection />
      <PropertiesSection />
      <TestimonialsSection />
      <ClientsSection />
      <BlogSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
